import { useEffect, useState } from "react";

const SHOW_AFTER_PX = 600;

export default function MastheadReturn() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <>
      <style>{`
        .vi-masthead-return {
          position: fixed;
          left: clamp(14px, 2vw, 28px);
          bottom: 84px;
          z-index: 70;
          width: 72px;
          height: 72px;
          border-radius: 50%;
          background: var(--paper-1, #FAF6EA);
          border: 1px solid var(--brass-rule, rgba(168,132,61,0.35));
          box-shadow:
            0 1px 0 rgba(0,0,0,0.04),
            0 8px 24px rgba(60, 44, 18, 0.18),
            inset 0 0 0 4px rgba(168,132,61,0.06);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          cursor: pointer;
          padding: 0;
          color: var(--brass-deep, #846530);
          opacity: 0;
          transform: translateY(10px);
          pointer-events: none;
          transition:
            opacity 280ms ease,
            transform 280ms ease,
            border-color 200ms ease,
            box-shadow 200ms ease;
        }
        .vi-masthead-return.is-visible {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        }
        .vi-masthead-return:hover,
        .vi-masthead-return:focus-visible {
          border-color: var(--brass, #A8843D);
          transform: translateY(-2px);
          box-shadow:
            0 1px 0 rgba(0,0,0,0.04),
            0 12px 28px rgba(60, 44, 18, 0.22),
            inset 0 0 0 4px rgba(168,132,61,0.10);
          outline: none;
        }
        .vi-masthead-return svg {
          display: block;
        }
        .vi-masthead-return .vi-mr-rule {
          width: 28px;
          height: 1px;
          background: var(--brass-rule, rgba(168,132,61,0.45));
        }
        .vi-masthead-return .vi-mr-label {
          font-family: 'JetBrains Mono', 'Söhne Mono', ui-monospace, monospace;
          font-size: 8px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: var(--brass-deep, #846530);
          line-height: 1;
        }
        @media (max-width: 640px) {
          .vi-masthead-return {
            left: 14px;
            bottom: 72px;
            width: 60px;
            height: 60px;
            gap: 3px;
          }
          .vi-masthead-return .vi-mr-rule { width: 22px; }
          .vi-masthead-return .vi-mr-label { font-size: 7px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .vi-masthead-return { transition: opacity 120ms linear; }
          .vi-masthead-return:hover { transform: none; }
        }
      `}</style>

      <button
        type="button"
        onClick={handleClick}
        aria-label="Return to top of page"
        title="Return to masthead"
        className={`vi-masthead-return${visible ? " is-visible" : ""}`}
      >
        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" aria-hidden="true">
          <path
            d="M1 8L7 1.5L13 8"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="square"
          />
        </svg>
        <span className="vi-mr-rule" aria-hidden="true" />
        <span className="vi-mr-label">Masthead</span>
      </button>
    </>
  );
}
